"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.PAX_TYPE = exports.PAX_MAX_AGE = exports.FIELDS = void 0;
var TRANSLATION = {
  travellingWith: 'Travelling with'
};
exports.TRANSLATION = TRANSLATION;
var FIELDS = {
  travellingWith: {
    label: TRANSLATION.travellingWith,
    name: 'travellingWith'
  }
};
exports.FIELDS = FIELDS;
var PAX_TYPE = {
  adult: TRANSLATION.adult,
  child: TRANSLATION.child,
  infant: TRANSLATION.infant
};
exports.PAX_TYPE = PAX_TYPE;
var PAX_MAX_AGE = {
  adult: {
    min: 18
  },
  child: {
    min: 3,
    max: 18
  },
  infant: {
    min: 0,
    max: 2
  }
};
exports.PAX_MAX_AGE = PAX_MAX_AGE;